export function getLoginRedirectTarget(to, from) {
  if (typeof to.query?.redirect === 'string' && to.query.redirect !== '/login') {
    return to.query.redirect;
  }

  if (from?.fullPath && from.fullPath !== '/login' && from.fullPath !== '/logout') {
    return from.fullPath;
  }

  return '/';
}
